import CollectionList from "@/js/Shared/Collections/CollectionList";
import EventProgress  from "@/js/Shared/Events/EventProgress";
import MessageItem    from "../Entities/Message/MessageItem";

export {MessagesCollection as default};

/**
* Messages List Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesCollection extends CollectionList {
  /**
   * Message list folder Label
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  folder_label;

  /**
   * Message list Folder id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
   folder_id;

  /**
   * The total of messages in the mailbox
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {string}
   */
  folder_total = 0;

  /**
   * List Cache id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {string}
   */
  cache_id;

  /**
   * Next uid
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  uidnext = 0;

  /**
   * Defines message list sort by flag
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  sort_by;

  /**
   * Defines message list sorrt direction
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  sort_direction;

  /**
   * Defines messages list slice size
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  slice = 0;

  /**
   * Mailbox range list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  range_list = [];

  /**
   * Messages Event Progress
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {EventProgress}
   */
  event_progress = new EventProgress();

  /**
   * Constructor
   *
   * @public
   *
   * @since 7.0.0
   */
  constructor() {
    super('id');
  }

  /**
   * Retrieves a message item from the collection
   *
   * Returns an empty item if message does not exist in the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} message_id
   *
   * @return {MessageItem}
   */
  get(message_id) {
    return this.index[message_id] || new MessageItem();
  }

  /**
   * Sorts message items according to given orden
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} order messages order
   *
   * @return {MessageItem}
   */
  sortItems(order) {
    const items = new Array(Object.keys(order).length);

    for (let message_id in order) {
      let position    = order[message_id] - 1;
      items[position] = this.index[message_id];
    }

    this.items = items.filter(Boolean);
  }

  /**
   * Resets Collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  reset() {
    this.range_list   = [];
    this.folder_total = 0;
    this.uidnext      = 0;
    this.slice        = 0;
    super.reset();
  }
}